<template>
    <m-layout>
      <div fill-height class="fill-height" style="max-width:100%; position:relative">
        <v-card-title class="m-page__title">
          <span class="headline">Insurances</span>
          <v-btn icon class="mx-0" @click="onRefresh">
             <v-icon color="primary">refresh</v-icon>
          </v-btn>
        </v-card-title>
        <m-confirm ref="confirm"></m-confirm>
        <m-notify-form ref="notify"></m-notify-form>
        <m-form :form="form" :dialog="dialog" @save="onSave" @close="onClose"></m-form>
        <m-edit-form :user="selectedItem" :form="form" :dialog="dialog_edit" @update="onUpdate" @close="onClose"></m-edit-form>


        <v-card style="max-width:100%; position:relative">

          <v-card-title>
            <v-btn
              absolute
              dark
              fab
              top
              right
              color="primary"
              @click.native.stop="dialog = true">
              <v-icon>add</v-icon>
            </v-btn>

            <v-text-field
              append-icon="search"
              label="Search"
              single-line
              hide-details
              v-model="search"
            ></v-text-field>
          <!--
            <v-btn icon color="primary" @click="notify">
              <v-icon>notifications_none</v-icon>
            </v-btn>
            -->
            <v-spacer></v-spacer>
          </v-card-title>
          <v-data-table
              v-bind:headers="headers"
              v-bind:items="items"
              v-bind:search="search"
              :sort-by="['id']"
              :sort-desc="[true]"
              :footer-props="{
                'items-per-page-options': [30, 40, {text:'All', value:-1}]
              }"
              dense
            >
          <template v-slot:body="{ items }">
            <tbody>
              <tr v-for="item in items" :key="item.id">

              <td >{{ item.id }}</td>
              <td >{{ item.name }}</td>
              <td >{{ item.address }}</td>
              <td >{{ item.zip }}</td>
              <td >{{ item.city }}</td>
              <td >{{ item.tel }}</td>
              <td >{{ item.email }}</td>
              <td >{{ item.bank_account }}</td>
              <td>
                <div style="display: flex">
                <v-btn icon class="mx-0" @click="editItem(item)">
                  <v-icon color="primary">edit</v-icon>
                </v-btn>
                <v-btn icon class="mx-0" @click="deleteItem(item)">
                  <v-icon color="primary">delete</v-icon>
                </v-btn>
                </div>
              </td>
            </tr>
            </tbody>
          </template>
          <template slot="pageText" slot-scope="{ pageStart, pageStop }">
            From {{ pageStart }} to {{ pageStop }}
          </template>
        </v-data-table>
      </v-card>


    </div>
  </m-layout>
</template>

<script>
  import Confirm from '../../components/confirm.vue'
  import Form from '../../components/insurance/form.vue'
  import EditForm from '@/components/insurance/edit.vue'
  import NotifyMessage from '../../components/notification/notify'
  /*
  id
  firstname
  lastname
  address
  zip
  city
  birthday
  tel
  mobile
  role
  car
  zones
  email
  password
  client_from
  */
  export default {
    components: {
      'm-confirm': Confirm,
      'm-form': Form,
      'm-edit-form': EditForm,
      'm-notify-form': NotifyMessage
    },
    data () {
      return {
        form: {},
        dateFormatted: null,
        dialog: false,
        dialog_edit: false,
        selectedItem: {},
        max25chars: (v) => v.length <= 25 || 'Input too long!',
        tmp: '',
        search: '',
        pagination: {},
        headers: [
          {
            text: 'ID',
            align: 'left',
            sortable: false,
            value: 'id'
          },
          { text: 'Name', value: 'firstname' },
          { text: 'Address', value: 'address' },
          { text: 'Zip', value: 'zip' },
          { text: 'City', value: 'city' },
          { text: 'Tel', value: 'tel' },
          { text: 'Email', value: 'email' },
          { text: 'Bank nr.', value: 'bank_account' },
          { text: 'Action', value: 'action' }
        ],
        items: [
          {
            value: false
          }
        ]
      }
    },
    methods: {
      formatDate (date) {
        if (!date) {
          return null
        }
        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },
      onSave (data) {
        console.log('save2', data);
        this.sendForm(data);
        this.dialog = false;
      },
      onClose () {
        this.dialog = false;
        this.dialog_edit = false;
        this.reset();
        console.log('close');
      },
      onUpdate (data) {
        console.log('update user: ' + this.selectedItem.id, data);
        this.updateForm(data);
        this.onClose();
      },
      reset () {
        this.form = {};
      },
      onRefresh () {
        this.getData();
      },
      sendForm (data) {
        // var app = this;
        this.$http
        .post('api/insurance', data)
        .then(response => {
          console.log('response data', response.data);
          this.onClose();
          this.getData();
          // app.items = response.data;
        })
        .catch(function (error) {
          console.log('catch:', error);
        });
      },
      updateForm (data) {
        // var app = this;
        var id = this.selectedItem.id;
        this.$http
        .put('api/insurance/' + id, data)
        .then(response => {
          console.log('response data', response.data);
          this.onClose();
          this.getData();
          // app.items = response.data;
        })
        .catch(function (error) {
          console.log('catch:', error);
        });
      },
      editItem (item) {
        this.reset();
        this.selectedItem = this.items.find(i => i === item);
        this.dialog_edit = true;
        console.log('edit', this.selectedItem.id);
      },
      deleteItem (item) {
        this.$refs.confirm.open('Delete', item.firstname + ' ' + item.lastname + ' ?').then((confirm) => {
          if (confirm) {
            this.$http
            .delete('api/insurance/' + item.id)
            .then(response => {
              console.log('user deleted', response.data);
              this.getData();
            })
            .catch(function (error) {
              console.log('catch:', error);
            });
          }
        });
      },
      notify (item) {
        this.$refs.notify.open(item).then((data) => {
          console.log('notify send: ', data);
          if (data) {
            this.$http
            .post('service/notification/message', data)
            .then(response => {
              console.log('notification sended', response);
            })
            .catch(function (error) {
              console.log('notification catch:', error);
            });
          }
        })
      },
      getData () {
        var app = this;
        this.$http
        .get('api/insurance')
        .then(response => {
          console.log('data', response.data);
          app.items = response.data;
        })
        .catch(function (error) {
          console.log('catch:', error);
        });
      },
      getDataById (id) {
        var app = this;
        return new Promise((resolve, reject) => {
          this.$http
          .get('api/insurance/' + id)
          .then(response => {
            console.log('insurance getDataById:', response.data);
            app.items = response.data;
            resolve(app.items);
          })
          .catch(function (error) {
            reject(error);
          });
        });
      },
      isDirectLink (item) {
        item = item || this.$route.params.item || {}
        if (item.id && item.route === this.$route.name) {
          this.getDataById(item.id).then((items) => {
            this.editItem(items[0]);
          });
          this.$route.params.item = null;
        }
      }
    },
    created () {
      this.getData();
      this.$bus.$on('search:show', this.isDirectLink);
    },
    mounted () {
      this.isDirectLink();
    },
    beforeDestroy () {
      this.$bus.$off('search:show', this.isDirectLink);
    }
  }
</script>











